import { ATLASSIAN_JSM_TOPICS } from '../config/education/topics/atlassian-jsm';
import type { EducationTopic } from '../components/education/EducationDrawer';

const TOPIC_REGISTRY: Record<string, EducationTopic> = {
  ...ATLASSIAN_JSM_TOPICS,
  // Add other topic files here as they are created
};

/**
 * Load an education topic by ID
 * Returns null if topic not found
 */
export function loadEducationTopic(topicId: string): EducationTopic | null {
  return TOPIC_REGISTRY[topicId] || null;
}

/**
 * Get all available topics (for debugging/admin)
 */
export function getAllTopics(): EducationTopic[] {
  return Object.values(TOPIC_REGISTRY);
}
